<script>
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';

export default {
  components: {
    LoadingState,
  },
  props: {
    config: {
      type: Array,
      default: () => [],
    },
    currentChat: {
      type: Object,
      default: () => ({}),
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      hasOpenedAtleastOnce: false,
      iframeLoading: true,
      // ۱. اضافه کردن وضعیت تم به داده‌های واکنش‌گرا برای فعال شدن watch
      currentTheme: localStorage.getItem('color_scheme') || 'light',
      themeObserver: null,
    };
  },
  computed: {
    dashboardAppContext() {
      return {
        conversation: this.currentChat,
        contact: this.$store.getters['contacts/getContact'](this.contactId),
        currentAgent: this.currentAgent,
        // ۲. استفاده از متغیر واکنش‌گرای دیتای کامپوننت
        theme: this.currentTheme,
      };
    },
    contactId() {
      return this.currentChat?.meta?.sender?.id;
    },
    currentAgent() {
      const { id, name, email } = this.$store.getters.getCurrentUser;
      return { id, name, email };
    },
  },
  watch: {
    isVisible() {
      if (this.isVisible) {
        this.hasOpenedAtleastOnce = true;
      }
    },
    // ۳. این همان واچی است که خواستید؛ به محض تغییر تم، اطلاعات جدید را به آی‌فریم می‌فرستد
    currentTheme(newTheme, oldTheme) {
      if (newTheme !== oldTheme) {
        // اگر چند آی‌فریم دارید، کانتکست جدید برای همه‌ی آن‌ها فرستاده می‌شود
        this.config.forEach((_, index) => {
          this.onIframeLoad(index);
        });
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.triggerEvent);
    // ۴. راه‌اندازی Observer برای رصد تغییرات تم در ریشه وب‌سایت
    this.initThemeObserver();
  },
  unmounted() {
    window.removeEventListener('message', this.triggerEvent);
    // ۵. پاک‌سازی ناظر برای جلوگیری از نشت حافظه (Memory Leak)
    if (this.themeObserver) {
      this.themeObserver.disconnect();
    }
  },
  methods: {
    initThemeObserver() {
      this.themeObserver = new MutationObserver(() => {
        const latestTheme = localStorage.getItem('color_scheme') || 'light';
        if (this.currentTheme !== latestTheme) {
          this.currentTheme = latestTheme;
        }
      });

      // رصد کردن تغییرات کلاسی روی تگ html
      this.themeObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    },
    triggerEvent(event) {
      if (!this.isVisible) return;
      if (event.data === 'chatwoot-dashboard-app:fetch-info') {
        this.onIframeLoad(0);
      }
    },
    getFrameId(index) {
      return `dashboard-app--frame-${this.position}-${index}`;
    },
    onIframeLoad(index) {
      const frameElement = document.getElementById(this.getFrameId(index));
      if (!frameElement) return; // اطمینان از وجود المنت در DOM

      const eventData = { event: 'appContext', data: this.dashboardAppContext };
      frameElement.contentWindow.postMessage(JSON.stringify(eventData), '*');
      this.iframeLoading = false;
    },
  },
};
</script>

<template>
  <div v-if="hasOpenedAtleastOnce" class="dashboard-app--container">
    <div
      v-for="(configItem, index) in config"
      :key="index"
      class="dashboard-app--list"
    >
      <LoadingState
        v-if="iframeLoading"
        :message="$t('DASHBOARD_APPS.LOADING_MESSAGE')"
        class="dashboard-app_loading-container"
      />
      <iframe
        v-if="configItem.type === 'frame' && configItem.url"
        :id="getFrameId(index)"
        :src="configItem.url"
        @load="() => onIframeLoad(index)"
      />
    </div>
  </div>
  <div v-else />
</template>

<style scoped>
.dashboard-app--container,
.dashboard-app--list,
.dashboard-app--list iframe {
  height: 100%;
  width: 100%;
}

.dashboard-app--list iframe {
  border: 0;
}
.dashboard-app_loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
</style>
